import { Auth } from 'aws-amplify';
import { store } from '../../../store';
import { getUserAPIResponseType } from '../types';
import { axiosWithToken } from '../../../utils/axios';

async function getAuthedUser() {
  try {
    return await Auth.currentAuthenticatedUser();
  } catch (error) {
    return null;
  }
}

export function set(key: string, contacts: any) {
  return store.setItem(key, contacts);
}

export const getUser = async () => {
  // retrieve login user info
  const userAuthed = await getAuthedUser();
  if (!userAuthed) {
    return null;
  }

  const user = await store.getItem('user');

  if (!user) {
    try {
      const res = (await axiosWithToken.get(
        `/users/${userAuthed.username}/`,
      )) as getUserAPIResponseType;
      set('user', res.data);
      return res.data;
    } catch (error) {
      return null;
    }
  }

  return user;
};

export async function postUser({ data }: any) {
  try {
    const res = await axiosWithToken.post(`/users/`, {
      data,
      isToken: true,
    })
    await set('user', res.data);
    return res;
  } catch (error) {
    return false;
  }
}
